/**
 * API DocsHome Template
 * By Srinivasa Upputuri <supputuri@svb.com> (www.svb.com)
 * Summary
 * This component renders Api Docs Home Page
 */
import React from 'react';
import { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { SVBSlogans } from '@svb/svb-react-components';
import DocsHomeWidgets from './DocsHomeWidgets';
import DocsHomeApisInvolved from './DocsHomeApisInvolved';
import { getDocsHomeDetails } from './helper';
import { SVBCTABlock } from '@svb/portal-ui-react-components';
// import {SVBCTABlock, SVBFaqApiContextualSupport} from "@svb/portal-ui-react-components";
// import {useStore} from "../../core/useStore";
import Loading from '@svb/api-loading-component/dist/components';
import MetaTags from '../../core/MetaTags';
import { SVBErrorPageRenderer } from '../../helpers/utilityFunctions';

/**
 * DocsHome
 * @param contentUrl: url of the docs home md content
 * @returns DocsHome Page with Header, Widget Cards and Api Cards
 */
const DocsHome = ({ dataTestId, testMockContent, ...props }) => {
  const { contentUrl } = props;
  const [loading, setLoading] = useState(true);
  const [ismounted, setIsmounted] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorStatusCode, setErrorStatusCode] = useState('');
  const [errorDefaultMessage, setErrorDefaultMessage] = useState(
    'It happens sometimes, you may refresh the page or go to home.',
  );
  // const supportFaqsItems = useStore((state) => state.faqsItems);
  // let url = props?.contentUrl ? props?.contentUrl : '';

  const docHomeDetails = dataTestId
    ? testMockContent
    : getDocsHomeDetails(contentUrl, 'docs-home.md');

  useEffect(() => {
    setIsmounted(true);
  }, []);

  useEffect(() => {
    setIsError(false);
    if (docHomeDetails.type === 'success') {
      setLoading(false);
    }

    if (docHomeDetails.type === 'error') {
      setIsError(true);
      setErrorStatusCode(docHomeDetails?.errorStatusCode);
      !docHomeDetails?.errorStatusCode && setErrorDefaultMessage(docHomeDetails?.response);
      setLoading(false);
    }
  }, [docHomeDetails.response]);

  const DocsHero = ({ ...props }) => {
    return (
      <>
        <SVBSlogans
          title={props?.title}
          description={props?.description}
          image={props?.image}
          extraClasses={'svb-breadcrumb-header-color justify-content-between'}
          breadCrumbs={[
            { breadCrumb: 'Home', link: '/', dataTestId: 'breadcrumb-docs-home' },
            { breadCrumb: 'Docs Home', link: '#', dataTestId: 'breadcrumb-docs-docs-home' },
          ]}
        ></SVBSlogans>{' '}
      </>
    );
  };

  if (isError) {
    return (
      <SVBErrorPageRenderer
        errorStatusCode={errorStatusCode}
        defaultErrorMessage={errorDefaultMessage}
      />
    );
  }
  return (
    <>
      {/*Generate metadata once component/template mounts */}
      {ismounted && (
        <MetaTags
          title={'Docs Home'}
          sitename={'SVB Developer Portal'}
          description={
            'Guides, Specifications, and other developer resources to help you build with SVB'
          }
          image={window.location.protocol + '//' + window.location.host + '/svb_fcb_logo_new.svg'}
          keywords={
            'svb, silicon valley bank, api, developer, portal, integration, fcb, first citizens, documentation'
          }
          type='website'
          author='Silicon Valley Bank'
        />
      )}

      {/*render page elements once data is available */}
      {loading ? (
        <Loading />
      ) : (
        docHomeDetails?.response && (
          <>
            <div className='row' id='docs-home-content'>
              <Markdown
                options={{
                  overrides: {
                    Hero: {
                      component: DocsHero,
                      props: props,
                    },
                    FeatureCards: {
                      component: DocsHomeWidgets,
                      props: props,
                    },
                    SolutionDetailsApisInvolved: {
                      component: DocsHomeApisInvolved,
                      props: props,
                    },
                    SVBCTABlock: {
                      component: SVBCTABlock,
                      props: props,
                    },
                  },
                }}
              >
                {docHomeDetails?.response}
              </Markdown>
              {/* <div className='common-contextual-support'>
                  <SVBFaqApiContextualSupport 
                filterOption={{
                  resultCount : 3,
                  filterType: 'common',
                  filterValue: 'common',
                  filterDisplayName: 'common'
                }} 
                faqsData={supportFaqsItems} 
                extraClasses="container svb-container-fixed mb-10 pt-10 pb-10"
                />
                </div> */}
            </div>
          </>
        )
      )}
    </>
  );
};

export default DocsHome;
